import { IconButton, Tooltip } from "@material-ui/core";
import React, { useState } from "react";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import CopyToClipboard from "react-copy-to-clipboard";
import PropTypes from "prop-types";

function TextCopyButton(props) {
  const { text, tooltipTitle, ...rest } = props;
  const [tooltipTitleState, setTooltipTitleState] = useState(tooltipTitle);

  function handleClickCopy() {
    setTooltipTitleState("Copied");
    setTimeout(() => setTooltipTitleState(tooltipTitle), 1500);
  }

  return (
    <CopyToClipboard text={text} onCopy={handleClickCopy}>
      <Tooltip title={tooltipTitleState} placement="top" arrow interactive leaveDelay={1000}>
        <IconButton {...rest} style={{ padding: "8px", fontSize: "inherit" }} color="primary">
          <FileCopyOutlinedIcon style={{ fontSize: "inherit" }} />
        </IconButton>
      </Tooltip>
    </CopyToClipboard>
  );
}

export default TextCopyButton;

TextCopyButton.propTypes = {
  ...IconButton.propTypes,
  text: PropTypes.string.isRequired,
  tooltipTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

TextCopyButton.defaultProps = {
  text: "",
  size: "small",
  tooltipTitle: "Copy",
};
